import { render } from "./ShowClient.vue?vue&type=template&id=f03b2382"
import script from "./ShowClient.vue?vue&type=script&lang=js"
export * from "./ShowClient.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__